import "@/App.css";
import { ReactLenis } from "lenis/react";
import Landing from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App">
        <div className="grain" aria-hidden="true" />
        <Landing />
        <Toaster position="top-center" />
      </div>
    </ReactLenis>
  );
}

export default App;
